import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled from 'styled-components';
import { responsiveThemeStyle } from "../../theme/responsive";
export var ColumnsContext = React.createContext(0);
export function Columns(_ref) {
  var _ref$gap = _ref.gap,
      gap = _ref$gap === void 0 ? 0 : _ref$gap,
      children = _ref.children,
      _ref$alignY = _ref.alignY,
      alignY = _ref$alignY === void 0 ? 'start' : _ref$alignY,
      _ref$alignX = _ref.alignX,
      alignX = _ref$alignX === void 0 ? 'start' : _ref$alignX,
      _ref$reverse = _ref.reverse,
      reverse = _ref$reverse === void 0 ? false : _ref$reverse,
      other = _objectWithoutProperties(_ref, ["gap", "children", "alignY", "alignX", "reverse"]);

  return /*#__PURE__*/React.createElement(ColumnsContext.Provider, {
    value: gap
  }, /*#__PURE__*/React.createElement(StyledColumns, _extends({
    $reverse: reverse,
    $gap: gap,
    $alignX: alignX,
    $alignY: alignY
  }, other), children));
}
var alignments = {
  start: 'flex-start',
  center: 'center',
  end: 'flex-end',
  baseline: 'baseline'
};
var responsiveSpace = responsiveThemeStyle('marginLeft', 'spaces');
var StyledColumns = styled.div.withConfig({
  displayName: "Columns__StyledColumns",
  componentId: "vapor__sc-1vojvtw-0"
})(["display:flex;align-items:", ";justify-content:", ";flex-direction:", ";", ";"], function (p) {
  return alignments[p.$alignY];
}, function (p) {
  return alignments[p.$alignX];
}, function (p) {
  return p.$reverse ? 'row-reverse' : 'row';
}, function (p) {
  return responsiveSpace(p.$gap, function (gap) {
    return "-".concat(gap);
  });
});